import React from 'react';
import { NavLink } from 'react-router-dom';
import Truncate from 'react-truncate';
import SVG from 'react-inlinesvg';
import { RouteUrls } from '../../../../configs/routeUrls';
import { ImageMimeType } from '../../../../utils/enums';
import { replaceEndOfLine } from '../../../../utils/text-extensions';
import { transformSVG } from '../../../../utils/svg-extensions';

const ZeroCurrency = 0;

export const ProjectTaskListItem = ({ ...props }) => (
	<div className="project-task">
		<div className="project-task__header">
			<div className="project-task__title">{props.title}</div>
			<div className="project-task__header-spec">
				<div className="project-task__infos">
					{!props.isOnlyOneOffice && (
						<div className="project-task__info">
							<div className="info__label">Jednostka:</div>
							<div className="info__value">{props.officeName}</div>
						</div>
					)}
					<div className="project-task__info">
						<div className="info__label">Obszar:</div>
						<div className="info__value">{props.districtName ? props.districtName : 'Miasto'}</div>
					</div>
					<div className="project-task__info">
						<div className="info__label">Kategoria:</div>
						<div className="info__value">{props.officeThematicAreaName}</div>
					</div>
					<div className="project-task__info">
						<div className="info__label">Szacowany koszt:</div>
						<div className="info__value">
							{props.cost ? (
								props.cost.toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' })
							) : (
								ZeroCurrency.toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' })
							)}
						</div>
					</div>
					<div className="project-task__info">
						<div className="info__label">Rok budżetowy:</div>
						<div className="info__value">{props.budgetYearValue}</div>
					</div>
					<div className="project-task__info">
						<div className="info__label">Status:</div>
						<div className="info__value">{props.statusName}</div>
					</div>
				</div>
				{props.thumbMainImage && (
					<figure className="thumbnail thumbnail--basis-50">
						{props.thumbMainImageContentType !== ImageMimeType.SVG && (
							<div className="svg-container">
								<img
									className="thumbnail__content"
									src={`data:image/jpeg;base64, ${props.thumbMainImage}`}
									alt={`Główne zdjęcie projektu ${props.title}`}
								/>
							</div>
						)}
						{props.thumbMainImageContentType === ImageMimeType.SVG && (
							<div className="svg-container">
								<div className="svg-item">
									<SVG
										src={transformSVG(
											props.thumbMainImage,
											`svg-project-${props.id}`,
											`Główne zdjęcie projektu ${props.title}`
										)}
									/>
								</div>
							</div>
						)}
					</figure>
				)}
			</div>
			<div className="project-task__description">
				<Truncate lines={7} ellipsis={<span>...</span>}>
					<div dangerouslySetInnerHTML={{ __html: replaceEndOfLine(props.description) }} />
				</Truncate>
			</div>
		</div>
		<div className="project-task__footer">
			<NavLink
				to={`${RouteUrls.Budget.projectTasks.preview}/${props.id}`}
				alt={`Przejdź do szczegółów projektu ${props.title}`}
				title={`Project ${props.title}`}
				className="project-task__button button button--16 button--primary-dark"
			>
				<span>Więcej</span>
			</NavLink>
		</div>
	</div>
);

ProjectTaskListItem.defaultProps = {
	id: 0,
	title: '',
	officeName: '',
	districtName: '',
	officeThematicAreaName: '',
	statusName: '',
	description: ''
};
